import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

/**
 * Nested under AuthGuard. Blocks /admin/** for non-admin users. Backend is
 * the real source of truth (every /api/admin/** endpoint checks system_role
 * server-side and returns 403), so this guard is just UX polish — it stops
 * the page chunk from loading when the user clearly has no business there.
 *
 * Falls through to /dashboard/review when the user is logged in but not an
 * admin, instead of /login, so admins-in-disguise (e.g. session refresh
 * timing) don't get bounced to the auth screen.
 */
export function AdminGuard() {
  const user = useAuthStore((s) => s.user);

  // While /api/auth/me is in flight, user is null but token exists. Render
  // nothing rather than flicker-redirecting; the parent Suspense boundary
  // covers the loading state.
  if (user && user.systemRole !== 'admin') {
    return <Navigate to="/dashboard/review" replace />;
  }

  return <Outlet />;
}
